<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XMw3Rg/tc-custom/9781426887703.jpg?1734559749918" alt="This image is the cover for the book Deadly Vows, The Francesca Cahill Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deadly Vows, The Francesca Cahill Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>When a blackmailer threatens her future, a society sleuth must turn to the one man she can’t resist in this sexy Gilded Age mystery.</b><br/><br/><i>New York City, 1902.</i> On the morning of her wedding to Calder Hart, amateur sleuth Francesca Cahill is lured away to a private viewing of a portrait that could destroy her entire family: the nude that Hart has commissioned of her. Her desperate quest to recover the scandalous portrait leads her into a dangerous trap—one that keeps her from meeting Hart at the altar. And when Francesca finally arrives at the church, she finds it vacant.<br/><br/>With her engagement over and a blackmailer intent on destroying her reputation, Francesca turns to Rick Bragg, the city’s powerful police commissioner. Together they scour the sordid streets of lower Manhattan, following a deliberately laid trail of clues in a race against the clock. And once it becomes clear that Bragg’s marriage is failing, Francesca must war with her feelings for him, battle Hart’s jealousy and escape a killer—all as she fights to win Hart back. But sometimes, passion just cannot be denied . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brenda Joyce
      </h2>
      
      <p class="authorDescription body article">Brenda Joyce is a New York Times bestselling author of more than 50 novels and novellas, including the popular and critically acclaimed de Warenne Dynasty Saga, a series of novels set in Regency and Victorian England. She lives on a ranch in Arizona with her dogs, broodmares and the year&rsquo;s current crop of foals. If she isn&rsquo;t on the back of a reining horse, she can be found madly at work in her office, penning her latest romance novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a42e6f4